// Game constants and configuration

// Team color palette — keys match backend VALID_TEAM_COLORS.
// All Tailwind classes are written statically here so the JIT scanner picks them up.
export const TEAM_COLORS = {
  gold:   { hex: "#f59e0b", bg: "bg-amber-500/20",   border: "border-amber-500/30",   text: "text-amber-400"   },
  red:    { hex: "#ef4444", bg: "bg-red-500/20",     border: "border-red-500/30",     text: "text-red-400"     },
  blue:   { hex: "#3b82f6", bg: "bg-blue-500/20",    border: "border-blue-500/30",    text: "text-blue-400"    },
  green:  { hex: "#10b981", bg: "bg-emerald-500/20", border: "border-emerald-500/30", text: "text-emerald-400" },
  purple: { hex: "#a855f7", bg: "bg-purple-500/20",  border: "border-purple-500/30",  text: "text-purple-400"  },
  cyan:   { hex: "#06b6d4", bg: "bg-cyan-500/20",    border: "border-cyan-500/30",    text: "text-cyan-400"    },
  orange: { hex: "#f97316", bg: "bg-orange-500/20",  border: "border-orange-500/30",  text: "text-orange-400"  },
  pink:   { hex: "#ec4899", bg: "bg-pink-500/20",    border: "border-pink-500/30",    text: "text-pink-400"    },
};

export const DEFAULT_TEAM_COLOR = TEAM_COLORS.gold;

// Phase definitions
export const PHASES = [
  { id: "pitch", label: "Pitching", desc: "Pitcher vs Batter roll" },
  { id: "fielding", label: "Fielding", desc: "D6 fielding roll" },
  { id: "bases", label: "Baserunners", desc: "Runners on base" },
];

// Scoring toast phrases with player name placeholders
export const SCORING_PHRASES = {
  1: [
    "{1} touches home plate!",
    "{1} crosses the dish!",
    "{1} trots home!",
    "{1} cashes in!",
    "{1} rings the bell!",
    "{1} puts one on the board!",
    "That's a run for {1}!",
    "{1} dances home!"
  ],
  2: [
    "{1} and {2} both score!",
    "{1} and {2} cross the plate!",
    "Two runs! {1} and {2} cash in!",
    "{1} and {2} make 'em pay!",
    "Here comes {1}... and {2}! Double trouble!",
    "{1} scores! {2} right behind!"
  ],
  3: [
    "{1}, {2}, and {3} all score!",
    "Three runs! {1}, {2}, {3} cross the dish!",
    "{1}, {2}, and {3} - that's a crooked number!",
    "The floodgates open! {1}, {2}, {3} all come home!",
    "Traffic on the basepaths pays off! {1}, {2}, {3} score!"
  ],
  4: [
    "GRAND SLAM! {1}, {2}, {3}, and {4} all score!",
    "SALAMI! {1}, {2}, {3}, {4} - clear the bases!",
    "GRAND SALAMI! Four runs come in! {1}, {2}, {3}, {4}!",
    "BOOM GOES THE DYNAMITE! {1}, {2}, {3}, and {4} all touch home!"
  ],
  victory: [
    "GAME OVER! {1} wins!",
    "VICTORY! {1} takes the game!",
    "CHAMPIONS! {1} emerges victorious!",
    "BALLGAME! {1} seals the victory!",
    "WINNERS! {1} claims the win!",
    "TRIUMPH! {1} conquers the field!"
  ]
};

{/*
// Victory modal phrases
export const VICTORY_PHRASES = [
  "That's how you finish a ballgame!",
  "The fans are going wild!",
  "A performance for the ages!",
  "They came, they saw, they conquered!",
  "Pure baseball magic right there!",
  "This one's going in the record books!",
  "What a way to cap off the game!",
  "The dugout is celebrating!",
  "That's championship-caliber baseball!",
  "History made on the diamond today!"
];
*/}

// Field positions - DEFAULT positions (percentage-based for responsive scaling)
export const POSITIONS = {
  // Outfield
  CF:  { x: 50, y: 12 },
  LF:  { x: 22, y: 22 },
  RF:  { x: 78, y: 22 },
  // Infield
  SS:  { x: 40, y: 42 },
  "2B": { x: 60, y: 42 },
  "3B": { x: 26, y: 54 },
  "1B": { x: 74, y: 54 },
  // Pitcher - on the mound
  P:   { x: 50, y: 56 },
  // Catcher - behind home plate
  C:   { x: 50, y: 80 },
  // Batter positions - at home plate
  BAT_R: { x: 46, y: 73 },
  BAT_L: { x: 54, y: 73 },
};

// Base coordinates for runner positions (must match SVG base centers in DiamondField)
export const BASE_COORDS = {
  home: { x: 50, y: 75 },
  first: { x: 70, y: 55 },
  second: { x: 50, y: 35 },
  third: { x: 30, y: 55 },
};

// Home run phrases
export const HR_PHRASES = {
  1: [
    "{1} goes yard! SOLO SHOT!",
    "{1} launches one outta here!",
    "{1} with a no-doubter!",
    "SEE YA! {1} crushes it!"
  ],
  2: [
    "{1} and {2} come around! 2-RUN SHOT!",
    "{1} scores, {2} follows - BOOM!",
    "Two runs! {1} and {2} touch 'em all!"
  ],
  3: [
    "{1}, {2}, and {3} all score! 3-RUN BLAST!",
    "Three runs come in! {1}, {2}, {3}!",
    "{1}, {2}, {3} - that's a big fly!"
  ],
  4: [
    "GRAND SLAM! {1}, {2}, {3}, and {4}!",
    "SALAMI! {1}, {2}, {3}, {4} all come home!",
    "GRAND SALAMI! Four runs! {1}, {2}, {3}, {4}!",
    "BASES CLEARING SLAM! {1}, {2}, {3}, and {4}!"
  ]
};

// Debug flag for coordinate display
export const SHOW_COORDINATES = false;
